import { render, staticRenderFns } from "./OrgHeader.vue?vue&type=template&id=77ccb768&scoped=true&lang=pug"
import script from "./OrgHeader.vue?vue&type=script&lang=js"
export * from "./OrgHeader.vue?vue&type=script&lang=js"
import style0 from "./OrgHeader.vue?vue&type=style&index=0&id=77ccb768&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77ccb768",
  null
  
)

export default component.exports